import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [username, setUsername] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/session')
      .then((res) => {
        if (res.data.authenticated) setUsername(res.data.username);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (u, p) => {
    const res = await api.post('/login', { username: u, password: p });
    setUsername(res.data.username);
  }, []);

  const logout = useCallback(async () => {
    await api.post('/logout');
    setUsername(null);
  }, []);

  return (
    <AuthContext.Provider value={{ username, loading, isAuthenticated: !!username, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
